// PACKAGES
import React from 'react';
import ReactDOM from 'react-dom';
// STYLES
import './main.scss';
// CONFIG
import { initializeConfig } from './config/config.production';

const container = document.createElement('div');
container.id = 'main';
document.body.appendChild(container);

initializeConfig() // Initialize the configuration
  .then(() => {
    import('./App') // Dynamically import the App component to avoid loading it until the configuration is ready
      .then(({ default: App }) => { ReactDOM.render(<App />, container); }) // Mount the App component
      .catch(error => {
        console.error('Failed to load the App component:', error);
        ReactDOM.render(
          <div>Failed to load the application. Please try again later.</div>,
          container
        );
      });
  })
  .catch(error => {
    console.error('Failed to initialize configuration:', error);
    ReactDOM.render(<div>Failed to load configuration. Please try again later.</div>, document.getElementById('root'));
  });
